var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-popover',{attrs:{"title":_vm.code,"destroyTooltipOnHide":true,"placement":"rightBottom"}},[_c('a',[_vm._v(_vm._s(_vm.code))]),_c('template',{slot:"content"},[(_vm.loading)?_c('a-spin',{staticClass:"chart"}):_c('div',{staticStyle:{"width":"400px"}},[_c('MarketRtChart',{attrs:{"code":_vm.code}})],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }